var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-tags-container"},_vm._l((_vm.tags),function(tag){return (tag !== '')?_c('span',{key:tag + _vm.uuid,class:{ sm: _vm.size === 'sm', lg: _vm.size === 'lg', md: _vm.size === 'md'},style:({'background-color': tag.color})},[_vm._v(_vm._s(tag.text))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5506da50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorTags.vue
// module id = null
// module chunks = 